import { ChecklistOutlined } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { useBomItemIssueDescription } from 'features/BillOfMaterials/components/useBomItemIssueDescription'
import { useBomItemDetailsDialog } from 'features/BomItemDetailsDialog/useBomItemDetailsDialog'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { IssueDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export const UpperSideSelectionTodo = (props: {
  bomItemPointer: BomItemPointer
  issue: IssueDto
}) => {
  const openBomItemDetailsDialog = useBomItemDetailsDialog()
  const { getIssueDescription } = useBomItemIssueDescription()

  const setDetailsOpen = () => {
    openBomItemDetailsDialog('models', {
      bomItemPointer: props.bomItemPointer,
    })
  }

  /* const { getIssueDescription } = useBomItemIssueDescription()

  const dispatch = useAppDispatch()
  const setDetailsOpen = (e) => {
    e.stopPropagation()

    dispatch(
      uiActions.openModal({
        modalType: 'BomItemDetailsV2',
        modalProps: {
          bomItemPointer: props.bomItemPointer,
          open: true,
          featureLabelDefaultExpanded: 'sides & walls',
        } as BomItemDetailsV2DialogProps,
      })
    )
  } */

  return (
    <Button
      component={'li'}
      style={{
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
      onClick={setDetailsOpen}
      color="inherit"
      startIcon={<ChecklistOutlined />}
    >
      <Typography variant="body2">
        {getIssueDescription(props.issue)}
      </Typography>
    </Button>
  )

  // return (
  //   <LocalizedButton
  //     defaultText="select upper side using the 3d viewer"
  //     translationKey="project:select-upper-side"
  //     variant="text"
  //     onClick={setDetailsOpen}
  //   />
  // )
}
